import { GenericService } from 'services/genericService';
import { Observable } from 'rxjs';
import api from 'utils/api';
import { UsageLogos } from 'utils/api/models/usageLogos/usageLogos';

export class UsageLogosService extends GenericService {
	public static getUsageLogos(): Observable<UsageLogos> {
		return api.wcm
			.getUsageLogos()
			.withErrorHandling()
			.call();
	}

	public static getImageByPartialPath(partialPath: string): string {
		return api.wcm.getImagePartialPath(partialPath);
	}
}
